module.exports = __webpack_public_path__ + "static/japan-0fea62c545e1d8016e29709d57906ad5.svg";